export default __webpack_public_path__ + "static/media/LENS_CULINARIS_TEKAY_fragment_2.f798be13.jpg";